import React from "react";
import { A } from "../routes";
import { getPremiumUpgradeTarget } from '../misc';

export const SettingsPremiumBadge = ({ is_market }) => {
  const badge = (
    <span className="badge prem_badge">Premium</span>
  );

  return (
    <React.Fragment>
      {is_market ? (
        <div className="prem_badge_markets_container">
          <a href={getPremiumUpgradeTarget()} target="_blank" rel="noopener noreferrer">{badge}</a>
        </div>
      ) : (
        <a href={getPremiumUpgradeTarget()} className="ml-2" target="_blank" rel="noopener noreferrer">
          {badge}
        </a>
      )}
    </React.Fragment>
  );
};


// WEBPACK FOOTER //
// ./src/c/SettingsPremiumBadge.js